// © Microsoft Corporation. All rights reserved.

import ContentSocialBar from "../content-social-bar/ContentSocialBar";
import React from "react";
import { SocialProps } from "../Social.props";

const testContentIds = [
    "BB18FZrJ",
    "BBBMTFk",
    "BB18gTBG",
    "BB18tU9T",
    "BB18u3Q2",
    "BB18u9Ar"
];

class MultipleContentTest extends React.Component<SocialProps> {

    constructor(props) {
        super(props);
    }

    render() {
        const propsToPass = { ...this.props };
        return (
            <div>
                <h1>MultipleContentTest</h1>
                <div>
                    {testContentIds.map((contentId, index) => {
                        const props = { ...propsToPass };
                        props.id = contentId;
                        return <div key={index}>
                            <ContentSocialBar { ...props } />
                        </div>;
                    })}
                </div>
            </div>
        );
    }
}

export default MultipleContentTest;